import React, {FunctionComponent, useState} from 'react';
import {Button, Collapse} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

interface SettingsCardProps {
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const SettingsCard: FunctionComponent<SettingsCardProps> = ({
  isOpen,
  onToggle,
  children,
}: SettingsCardProps) => {
  return (
    <div className="collapse-card">
      <Button
          icon={IconNames.COG}
          minimal={true}
          onClick={onToggle}
          text="Settings"
          small={true}
          className="collapse-card__button"
        />
      <Collapse
        isOpen={isOpen}
        keepChildrenMounted={true}
        transitionDuration={0}
      >
        {children}
      </Collapse>
    </div>
  );
};

export default SettingsCard;
